import { RoundingMethod } from 'typings/enums';

export class RoundingStrategy {

    private _roundingMethod: RoundingMethod;
    private _decimalPrecision: number;

    public get roundingMethod(): string {
        return this._roundingMethod;
    }

    public get decimalPrecision(): number {
        return this._decimalPrecision;
    }

    constructor(
        roundingMethod: RoundingMethod,
        decimalPrecision: number
    ) {
        this._roundingMethod = roundingMethod;
        this._decimalPrecision = decimalPrecision;
    }
}

export const DefaultRoundingStrategy = new RoundingStrategy(RoundingMethod.Absolute, 2);